"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePercentOfBalance = exports.getIsEventEnded = exports.getIsEventPending = exports.getBasketCardEventStatus = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const basket_types_1 = require("./basket.types");
const commonBasketCardEventStatus = {
    [betweb_openapi_axios_1.EventProbabilityTradingStatus.Suspended]: basket_types_1.EBasketCardEventStatusKey.LOADING,
    [betweb_openapi_axios_1.EventProbabilityTradingStatus.Settled]: basket_types_1.EBasketCardEventStatusKey.OUTCOME_NOT_AVAILABLE,
    [betweb_openapi_axios_1.EventProbabilityTradingStatus.Trading]: basket_types_1.EBasketCardEventStatusKey.OUTCOME,
};
const specificBasketCardEventStatus = {
    [betweb_openapi_axios_1.EventStatus.Cancelled]: basket_types_1.EBasketCardEventStatusKey.EVENT_CANCELED,
    [betweb_openapi_axios_1.EventStatus.Retired]: basket_types_1.EBasketCardEventStatusKey.EVENT_ENDED,
    [betweb_openapi_axios_1.EventStatus.Closed]: basket_types_1.EBasketCardEventStatusKey.EVENT_ENDED,
    [betweb_openapi_axios_1.EventStatus.Ended]: basket_types_1.EBasketCardEventStatusKey.EVENT_ENDED,
    [betweb_openapi_axios_1.EventStatus.Postponed]: basket_types_1.EBasketCardEventStatusKey.EVENT_POSTPONED,
    [betweb_openapi_axios_1.EventStatus.Interrupted]: basket_types_1.EBasketCardEventStatusKey.EVENT_INTERRUPTED,
    [betweb_openapi_axios_1.EventStatus.Suspended]: basket_types_1.EBasketCardEventStatusKey.EVENT_SUSPENDED,
    [betweb_openapi_axios_1.EventStatus.Open]: undefined,
    [betweb_openapi_axios_1.EventStatus.Trading]: undefined,
    [betweb_openapi_axios_1.EventStatus.Planning]: undefined,
};
const getBasketCardEventStatus = (eventStatus, probabilitiesCategoryStatus) => {
    if (specificBasketCardEventStatus[eventStatus] !== undefined) {
        // @ts-expect-error never return undefined
        return specificBasketCardEventStatus[eventStatus];
    }
    return commonBasketCardEventStatus[probabilitiesCategoryStatus];
};
exports.getBasketCardEventStatus = getBasketCardEventStatus;
const getIsEventPending = (status) => status === basket_types_1.EBasketCardEventStatusKey.LOADING;
exports.getIsEventPending = getIsEventPending;
const getIsEventEnded = (status) => status !== basket_types_1.EBasketCardEventStatusKey.LOADING &&
    status !== basket_types_1.EBasketCardEventStatusKey.OUTCOME;
exports.getIsEventEnded = getIsEventEnded;
const calculatePercentOfBalance = (balance, percentage) => {
    const value = (balance * percentage) / 100;
    return Math.round(value * 100) / 100;
};
exports.calculatePercentOfBalance = calculatePercentOfBalance;
//# sourceMappingURL=basket.js.map